import React from 'react';
import WithValidation, { IBaseInputElement, IInputElementBaseProps } from './input-validator/InputValidator';

export interface TextBoxProps extends IInputElementBaseProps<string> {
  rows?: number;
  type?: string;
  max?: number;
  min?: number;
  className?: string;
  onEnter?: () => void;
}

export interface TextBoxElement extends IBaseInputElement {}

function _TextBox(props: React.PropsWithChildren<TextBoxProps>) {
  const [isFocused, setFocused] = React.useState<boolean>(false);
  const multiline = props.rows && props.rows > 1;
  const showCharacterLimit =
    isFocused && props.max && props.value !== null && props.value !== undefined && props.value.length > 0;

  const onChange = (event: { target: { value: string } }) => {
    props.onChange(event.target.value);
  };

  const commonProps = (props: TextBoxProps) => {
    let commonProps: { [x: string]: any } = {
      className: `textbox ${props.className || ''} ${showCharacterLimit ? 'with-character-limit' : ''}`,
      placeholder: props.placeholder,
      value: props.value,
      onFocus: () => setFocused(true),
      onBlur: () => {
        setFocused(false);
        if (props.onBlur) props.onBlur();
      },
      onChange: onChange,
    };

    if (props.disabled === true) {
      commonProps.disabled = true;
    }

    return commonProps;
  };

  return (
    <div className="textbox-wrapper">
      {multiline ? (
        <textarea
          {...commonProps(props)}
          onKeyPress={e => props.onEnter && e.key === 'Enter' && props.onEnter()}
          rows={props.rows}
        />
      ) : (
        <input
          {...commonProps(props)}
          onKeyPress={e => props.onEnter && e.key === 'Enter' && props.onEnter()}
          type={props.type ? props.type : 'text'}
        />
      )}
      {showCharacterLimit && (
        <span
          className={
            'character-limit ' +
            (multiline ? '' : 'centered') +
            (props.max - props.value.length <= 10 ? ' warning' : '')
          }
        >
          {props.value.length}/{props.max}
        </span>
      )}
    </div>
  );
}

const TextBox = WithValidation<TextBoxElement, React.PropsWithChildren<TextBoxProps>, string>(_TextBox);
export default TextBox;
